import { useMatch, useLocation } from 'react-router-dom';
import type { ArtifactType } from '@/features/magic/contexts/ArtifactContext/artifact.lib';
import { useActiveArtifactType } from '@/features/magic/hooks/useActiveArtifactType';

type Ret = {
  isMagic: boolean;
  isMagicLandingPage: boolean;
  artifactType: ArtifactType | null;
};

export const useIsMagic = (): Ret => {
  const isMagic = useMatch('/magic/*') !== null;
  const { pathname } = useLocation();
  const isMagicLandingPage = /^\/magic-.*/.test(pathname);
  const { artifactType } = useActiveArtifactType();

  return {
    isMagic,
    isMagicLandingPage,
    artifactType: isMagic || isMagicLandingPage ? artifactType : null,
  };
};
